export const isEmail = (value) => {
  const pattern = /^\w+@[a-zA-Z_]+?\.[a-zA-Z]+$/;
  return value.match(pattern);
};

export const isPhone = (value) => {
  const pattern = /^\d+$/;
  return value.match(pattern) && value.length >= 6;
};

export const getDisplayName = (WrappedComponent) => {
  return WrappedComponent.displayName || WrappedComponent.name || "Component";
};

export const findAndUpdate = ({ sourceArray, by, byValue, objectToUpdate }) => {
  console.log("Source Array: ", sourceArray);
  sourceArray.every((item) => {
    if (item[by] === byValue) {
      Object.keys(objectToUpdate).forEach((k) => {
        item[k] = objectToUpdate[k];
      });
      return false;
    }
    return true;
  });
};
